import { api } from './api';

export interface LinkedInAccountOwner {
  id: number;
  name: string;
}

export interface LinkedInAccount {
  id: number;
  name: string;
  created_on: string | null;      // ISO date the LinkedIn account was created (age anchor)
  start_connections: number;
  current_connections: number;
  notes: string | null;
  archived: number;
  created_by: number | null;
  created_at: string;
  updated_at: string;
  // Geteiltes Login (Team-sichtbar): E-Mail + entschlüsseltes Passwort (server-seitig Fernet-verschlüsselt gespeichert)
  login_email: string | null;
  login_password: string | null;
  // owners (m:n with web_users) = Operatoren (wer darf senden)
  owners: LinkedInAccountOwner[];
  owner_ids: number[];
  // Inhaber (Identität): die eine Person, auf deren Namen alle Leads dieses Accounts laufen
  owner_web_user_id: number | null;
  owner_name: string | null;
  // FR-Tageslimit NUR dieses Accounts; null = das globale fr_daily_limit gilt
  daily_fr_limit: number | null;
  // derived warm-up fields (server-computed)
  age_days: number | null;
  connections_gained: number;
  is_warming_up: boolean;
  warmup_days: number;
  warmup_connections_target: number;
  normal_daily_limit: number;
  effective_daily_limit: number;
}

export interface LinkedInAccountInput {
  name?: string;
  created_on?: string | null;
  start_connections?: number;
  current_connections?: number;
  notes?: string | null;
  archived?: number;
  owner_ids?: number[];
  owner_web_user_id?: number | null;
  login_email?: string | null;
  login_password?: string | null;
  daily_fr_limit?: number | null;  // leer/0 = globales Limit
}

export const linkedinAccountsApi = {
  list: (includeArchived = false) =>
    api.get<LinkedInAccount[]>(`/linkedin-accounts${includeArchived ? '?include_archived=true' : ''}`),

  create: (data: LinkedInAccountInput) => api.post<LinkedInAccount>('/linkedin-accounts', data),

  update: (id: number, data: LinkedInAccountInput) =>
    api.patch<LinkedInAccount>(`/linkedin-accounts/${id}`, data),

  remove: (id: number) => api.delete<{ ok: boolean }>(`/linkedin-accounts/${id}`),
};
